<template>
  <div class="headerCart">
    <nuxt-link
      :to="
        editOrderId
          ? localePath({
              name: 'dashboard-orders-slug',
              params: { slug: editOrderId },
            })
          : localePath({ name: 'cart' })
      "
      class="headerCart__link"
      rel="nofollow"
    >
      <div class="headerCart__linkCount">
        <span class="headerCart__linkNumber">
          <span v-if="cartData">{{ cartData.totalQuantity }}</span>
          <span v-else>0</span>
        </span>
        <span v-if="editOrderId" class="headerCart__linkIcon icon-border-text" />
        <span v-else class="headerCart__linkIcon icon-basket" />
      </div>
      <div class="headerCart__linkContent">
        <div class="headerCart__linkPrice">
          <template
            v-if="
              cartData && cartData.total && (cartData.total.gross > 0 || cartData.total.net > 0)
            "
          >
            {{ cartData.grandTotal.currencyPrefix
            }}{{ showNetPrices ? cartData.total.netFormatted : cartData.total.grossFormatted }}
            {{ cartData.total.currencyPostfix }}
          </template>
        </div>
        <div class="headerCart__linkText">
          {{ editOrderId ? 'Zamówienie' : $t('myCart') }}
        </div>
      </div>
      <span class="headerCart__chevron icon-chevron-down" />
    </nuxt-link>
    <cart-dropdown class="headerCart__dropdown" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CartDropdown from '~/components/CartDropdown/CartDropdown';
import cartMixin from '~/mixins/cart.js';

export default {
  name: 'HeaderCart',
  components: {
    CartDropdown,
  },
  mixins: [cartMixin],
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
};
</script>

<style lang="scss">
.headerCart {
  $root: &;
  position: relative;
  margin-left: 1.5rem;

  @include rwd('laptop') {
    margin-left: 1rem;
  }

  @include rwd('small-tablet') {
    margin-left: 0.5rem;
  }

  &:hover {
    #{$root}__chevron {
      transform: rotate(180deg);
    }

    #{$root}__dropdown {
      top: 100%;
      opacity: 1;
      pointer-events: all;
    }
  }

  &__dropdown {
    @include rwd('laptop') {
      display: none;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__linkContent {
    @include rwd('large-tablet') {
      display: none;
    }
  }

  &__linkCount {
    position: relative;
    top: 2px;
  }

  &__linkNumber {
    position: absolute;
    right: 0;
    top: 0;
    width: 2rem;
    height: 2rem;
    padding-left: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: $cWhite;
    background-color: $cSec;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  &__linkIcon {
    margin-top: 2px;
    font-size: 1.8rem;
    color: $cMain;
    margin-right: 2.5rem;

    @include rwd('small-phone') {
      font-size: 1.7rem;
    }
  }

  &__linkPrice {
    color: $cMainDark;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 700;
  }

  &__linkText {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: $cAddDark02;
    font-weight: 600;
  }

  &__chevron {
    font-size: 7px;
    margin-left: 2rem;
    color: $cMainLight;
    transition: transform $tr;

    @include rwd('laptop') {
      display: none;
    }
  }
}
</style>
